'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

var _button = require('@alife/zoro-base/lib/button');

var _button2 = _interopRequireDefault(_button);

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _util = require('./util');

var _util2 = require('../util');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.sufei_jsonp_ignore = [/passport\.aliexpress\.com\/newlogin/]; // TODO REMOVE
var Login = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Login, _React$PureComponent);

    function Login() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Login);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || Object.getPrototypeOf(Login)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    // 语种，默认从cookie中取


    // 加载havana组件init初始化后得到的参数


    // 加载havana组件init初始化时的时间


    // 是否开启SmartLock功能


    // 从全局取到的xmanConfigAE对象


    // st相关缓存信息


    // st相关缓存信息


    // st相关缓存信息


    // 环境变量


    // 时间记录


    (0, _createClass3.default)(Login, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // 如果传进来enableSmartLock为true，在当前环境不支持的时候，还是把该变量设置为false
            if (this.props.enableSmartLock && !_util.isSmartLockSupported) {
                this.enableSmartLock = false;
            }

            this.locale = _i18n2.default.locale;

            this.loadXmanConfig();

            // 注册tab曝光打点
            (0, _util2.ctrDot)({
                expType: 'signin_tab'
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.miniLoginEmbedder._listeners = {};
            this.miniLoginEmbedder = null;
        }

        // 点击active-btn按钮


        // 点击validate-btn按钮


        // 初始化登录框，暴露给外界使用

    }, {
        key: 'render',
        value: function render() {
            // TODO wslogin-active-box 还有没有逻辑走到下面这个？这个样式还没有写
            return _react2.default.createElement(
                'div',
                { className: 'batman-login-wrap', id: this.id },
                this.state.showErrorTip ? _react2.default.createElement(
                    'p',
                    { className: 'wslogin-error-tip' },
                    this.props.appName === 'aeseller' ? '网络连接失败，请稍后再试' : _i18n2.default.UNAVIALABLE_SERVICE
                ) : null,
                this.state.showForbidTip ? _react2.default.createElement(
                    'p',
                    { className: 'wslogin-error-tip' },
                    _i18n2.default.FORBID_ACTIVE
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'login-active-box', style: this.state.showActiveBox ? { display: 'block' } : { display: 'none' } },
                    _react2.default.createElement('div', { className: 'wslogin-active-message', style: this.state.messageColorRed ? { color: 'red' } : { color: 'black' }, dangerouslySetInnerHTML: { __html: this.state.activeMessage } }),
                    this.state.showActiveBtn ? _react2.default.createElement(
                        _button2.default,
                        { size: 'small', type: 'primary', className: 'active-btn', onClick: this.onGotoActive },
                        _i18n2.default.GOTO_ACTIVE
                    ) : null,
                    this.state.showValidateBtn ? _react2.default.createElement(
                        _button2.default,
                        { size: 'small', type: 'primary', className: 'validate-btn', onClick: this.onCompleteActive },
                        _i18n2.default.COMPLETE_ACTIVE
                    ) : null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'a',
                        { className: 'other-account', onClick: this.onUseOtherAccount },
                        _i18n2.default.SIGN_UP_WITH_ANOTHER_ACCOUNT
                    )
                )
            );
        }
    }, {
        key: 'hideActiveBox',
        value: function hideActiveBox() {
            var loginbox = document.getElementById('alibaba-login-box');
            loginbox.parentElement.removeChild(loginbox);
            this.setState({
                showActiveBox: false
            });
        }
    }, {
        key: 'setXmanConfig',
        value: function setXmanConfig() {
            this.xmanConfig = window.ae_xman_config;

            // 如果外界没有设置该值, 但是接口中有并且当前浏览器支持的时候
            // TODO
            if (this.enableSmartLock === undefined && this.xmanConfig.isInBucket && _util.isSmartLockSupported) {
                this.enableSmartLock = true;
            }
            this.setUrl(this.xmanConfig);
            // 使用havana登陆框
            this.initHavana();
            // umid布点
            this.initUmid(this.xmanConfig);
        }

        // 请求xmanConfigAE.js，判断是否使用集团登陆框

    }, {
        key: 'loadXmanConfig',
        value: function loadXmanConfig() {
            var _this2 = this;

            if (window.ae_xman_config) {
                this.setXmanConfig();
            } else {
                this.props.toggleMask(true);
                (0, _zoroRequest2.default)({
                    url: 'https://login.aliexpress.com/xman/xman_config_new.htm',
                    type: 'script'
                }).then(function () {
                    _this2.setXmanConfig();
                }).catch(function () {
                    // TODO 这块不需要异常提示吗
                    _this2.props.toggleMask(false);
                });
            }
        }
    }, {
        key: 'init',


        // 初始化登录框
        value: function init(miniLoginEmbedder, opt) {
            var targetId = this.id;
            var locale = this.locale.replace('-', '_');

            // 监听登录完成后的消息，resize已被监听
            miniLoginEmbedder.addEvent('onMessage', this.onLoginMessage);
            this.miniLoginEmbedder = miniLoginEmbedder;

            var data = {
                targetId: targetId,
                appName: this.props.appName,
                iframeUrl: this.env.havanaIframeUrl,
                lang: locale,
                notKeepLogin: 'true',
                notLoadSsoView: opt.notLoadSsoView || this.props.notLoadSsoView || false,
                iframeHeight: 200,
                resizeIframeWidthFix: true,
                styleType: 'auto',
                loginId: opt.loginId || this.xmanConfig.xloginPassport || '',
                isMobile: this.props.isMobile
            };
            if (this.props.havanaQueryStr !== undefined && this.props.havanaQueryStr !== null) {
                data.queryStr = this.props.havanaQueryStr;
            }
            this.recordTime.iframeStartTime = Date.now();
            miniLoginEmbedder.init(data);
        }
    }, {
        key: 'initHavana',
        value: function initHavana() {
            var _this3 = this;

            var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // 请求havana登陆框所依赖的库文件
            // havana登陆框文档：http://docs.alibaba-inc.com/pages/viewpage.action?pageId=114734326
            if (window.MiniLoginEmbedder) {
                // 初始化havana登陆框
                var miniLoginEmbedder = new window.MiniLoginEmbedder();
                this.init(miniLoginEmbedder, opt);
                this.isIniting = true;
            } else {
                (0, _zoroRequest2.default)({
                    url: this.env.havanaEmbedJsUrl,
                    type: 'script'
                }).then(function () {
                    _this3.props.toggleMask(false);

                    var miniLoginEmbedder = new window.MiniLoginEmbedder();

                    _this3.init(miniLoginEmbedder, opt);
                    _this3.isIniting = true;
                }).catch(function (err) {
                    console.error(err);
                });
            }
        }

        // 接入umid，文档：http://docs.alibaba-inc.com/pages/viewpage.action?pageId=310807822

    }, {
        key: 'initUmid',
        value: function initUmid(config) {
            if (!config.needUMID) return;

            var umContainer = document.getElementById('_umfp');
            if (!umContainer) {
                umContainer = document.createElement('div');
                umContainer.id = '_umfp';
                umContainer.style.cssText = 'display:block;position:absolute;top:-5000px;left:-5000px;width:1px;height:1px;overflow:hidden;';
                document.body.appendChild(umContainer);
            }

            window._pointman_q = window._pointman_q || [];
            window._pointman_q.push(['um', function (umx) {
                var container = document.getElementById('_umfp');
                umx.init({
                    timeout: 15000,
                    serviceLocation: config.serviceLocation || 'us',
                    appName: 'intl-login',
                    token: config.u_token,
                    containers: { flash: container, dcp: container }
                });
            }]);

            (0, _zoroRequest2.default)({
                url: 'https://aeis.alicdn.com/sd/pointman/js/pt2.js?_=\'' + Math.floor(new Date().getTime() / 36e5),
                type: 'script'
            });
        }

        // 供外部调用SmartLock登录接口

    }, {
        key: 'smartLockFetch',
        value: function smartLockFetch(unmediated) {
            if (!this.enableSmartLock === true) {
                console.error("SmartLock isn't supported when invoking smartLockFetch() now!");
                return;
            }
            if (unmediated !== true) {
                unmediated = false;
            }
            this.doSmartLockFetch(this.fetchArgsCache, unmediated);
        }

        // havana框初始化后，判断是加载smartLock进入

    }, {
        key: 'doSmartLockFetch',
        value: function doSmartLockFetch(fetchArgs, unmediated) {
            var _this4 = this;

            if (_zoroCookie2.default.isLoggedIn()) {
                return;
            }
            var credentialsGetParam = this.isUseNewSmartlockApi ? {
                mediation: unmediated ? 'silent' : 'optional',
                password: true
            } : {
                unmediated: unmediated,
                password: true
            };

            navigator.credentials.get(credentialsGetParam).then(function (credential) {
                if (!credential) {
                    return;
                }
                if (credential.type === 'password') {
                    _this4.setDocDomain();
                    var newFrame = void 0;var frame = void 0;
                    try {
                        newFrame = document.getElementById('alibaba-login-box');
                        frame = newFrame.contentDocument || newFrame.contentWindow.document;
                        frame.getElementById('fm-login-password').setAttribute('placeholder', 'You are now signing in as ' + credential.id);
                        frame.getElementById('fm-login-id').value = credential.id;
                    } catch (e) {
                        _zoroArms2.default.error(e);
                    }
                    credential.idName = 'loginId';
                    credential.additionalData = new FormData();
                    var credentialFetchBody = new FormData();
                    credentialFetchBody.append('loginId', credential.id);
                    credentialFetchBody.append('password', credential.password);
                    for (var key in fetchArgs) {
                        if (Object.hasOwnProperty.call(fetchArgs, key)) {
                            credential.additionalData.append(key, fetchArgs[key]);
                            credentialFetchBody.append(key, fetchArgs[key]);
                        }
                    }
                    credential.additionalData.append('gsl', 'true');
                    credentialFetchBody.append('gsl', 'true');
                    var smartlockFetchParam = _this4.isUseNewSmartlockApi ? {
                        credentials: 'include',
                        body: credentialFetchBody,
                        method: 'POST'
                    } : {
                        credentials: credential,
                        method: 'POST'
                    };

                    fetch(_this4.env.smartlockLoginUrl, smartlockFetchParam).then(function (response) {
                        response.json().then(function (data) {
                            try {
                                if (document.getElementById('alibaba-login-box')) {
                                    var iFrame = document.getElementById('alibaba-login-box');
                                    data.content.data.aeLoginPattern = unmediated === true ? 'autoSmartLock' : 'smartLock';
                                    iFrame.contentWindow.miniLogin.handleLoginResult(data.content.data);
                                }
                            } catch (e) {
                                _zoroArms2.default.error(e);
                            }
                            _this4.restoreDocDomain();
                        });
                    }).catch(function () {
                        _this4.restoreDocDomain();
                    });
                } else {
                    // empty
                }
            });
        }
    }, {
        key: 'validateST',
        value: function validateST(st, passport, actived, aeLoginPattern) {
            var _this5 = this;

            var url = this.env.validateStUrl;
            var locale = this.locale.replace('-', '_');
            if (typeof aeLoginPattern === 'undefined' || aeLoginPattern === null || aeLoginPattern.indexOf('martLock') === -1) {
                aeLoginPattern = 'common';
            }
            var data = {
                st: st,
                language: locale,
                join_from: 'aliexpress',
                pattern: aeLoginPattern,
                passport: passport,
                u_token: this.xmanConfig.u_token,
                scene: this.props.scene
            };
            if (this.props.scene === 'oauth') {
                data.client_id = (0, _util.getUrlParameterByName)('client_id');
                data.redirect_uri = (0, _util.getDecodedUrlParameterByName)('redirect_uri');
                data.state = (0, _util.getUrlParameterByName)('state');
            }
            if (this.props.scene === 'AE_MAIN_LOGIN' || this.props.scene === 'AE_MSITE_LOGIN' || this.props.scene === 'oauth') {
                data.return_url = window.location.href;
            }
            if (actived) {
                data.verify_success = 'success';
            }
            if (this.havanaInitTime) {
                data.initTime = this.havanaInitTime.getTime();
            }
            if (window.dmtrack_pageid) {
                data.pageId = window.dmtrack_pageid;
            }

            this.props.toggleMask(true);

            (0, _zoroRequest2.default)({
                url: url,
                type: 'script',
                data: data,
                timeout: 5000
            }).then(function () {
                _this5.props.toggleMask(false);

                if ((typeof xman_success === 'undefined' ? 'undefined' : (0, _typeof3.default)(xman_success)) === 'object') {
                    // aliexpress登录成功
                    var _xman_success = window.xman_success;

                    // 保存帐号密码到google smartlock
                    if (_this5.enableSmartLock) {
                        try {
                            var avatarPath = null;
                            if (_xman_success.person_data && _xman_success.person_data.avatar_path) {
                                avatarPath = _xman_success.person_data.avatar_path;
                            } else {
                                avatarPath = 'https://img.alibaba.com//wimg/bison/single/default_header_pic.jpg';
                            }
                            _this5.smartLockSave(avatarPath);
                        } catch (e) {}
                    }

                    if (_this5.props.scene === 'oauth') {
                        _this5.props.afterLogin(_xman_success.redirect_uri);
                        return;
                    }

                    // 记录forceReturn url
                    // this.set('forceReturn', xman_success.forced_return); // TODO remove
                    // 后台需要重新获取umid
                    if (_xman_success.isNeedUmid == 'true') {
                        _this5.initUmid({
                            needUMID: true,
                            u_token: _xman_success.umidToken,
                            umidTimestamp: _xman_success.umidTimestamp,
                            serviceLocation: _xman_success.serviceLocation
                        });
                        _this5.xmanConfig.u_token = _xman_success.umidToken;
                    }
                    if (_xman_success.cancel_icbu_tvs != true) {
                        // 设置alibaba.com域cookie
                        var urlsArr = _xman_success.xlogin_urls;
                        if (urlsArr && urlsArr.length > 0) {
                            _this5.setTbsessionWithoutResponse(_xman_success.tbsessionToken);
                            _this5.setAlibabaCookie(urlsArr[0]);
                        }
                    } else {
                        _this5.setTbsession(_xman_success.tbsessionToken);
                    }
                } else if ((typeof need_activation === 'undefined' ? 'undefined' : (0, _typeof3.default)(need_activation)) === 'object') {
                    if (_this5.props.scene === 'AE_MAIN_LOGIN' || _this5.props.scene === 'AE_MSITE_LOGIN' || _this5.props.scene === 'oauth') {
                        window.location.href = _this5.env.tbActiveUrl + window.need_activation.token;
                    } else if (_this5.state.showActiveBox) {
                        _this5.notActive(); // 激活失败
                    } else {
                        // 出现一个按钮，打开邮箱验证页面
                        _this5.activeToken = window.need_activation.token;
                        _this5.showActiveBox();
                    }
                } else if ((typeof need_email_verification === 'undefined' ? 'undefined' : (0, _typeof3.default)(need_email_verification)) === 'object') {
                    window.location.href = _this5.env.emailVerificationUrl;
                } else if ((typeof sub_company_account_reject === 'undefined' ? 'undefined' : (0, _typeof3.default)(sub_company_account_reject)) === 'object') {
                    _this5.setState({
                        showForbidTip: true
                    });
                    setTimeout(function () {
                        _this5.setState({
                            showForbidTip: false
                        });
                    }, 5000);
                } else if ((typeof xlogin_failed === 'undefined' ? 'undefined' : (0, _typeof3.default)(xlogin_failed)) === 'object') {
                    _this5.setState({
                        showErrorTip: true
                    });

                    setTimeout(function () {
                        _this5.setState({
                            showErrorTip: false
                        });
                    }, 5000);
                }
            }).catch(function () {
                _this5.props.toggleMask(false);
                _this5.setState({
                    showErrorTip: true
                });

                setTimeout(function () {
                    _this5.setState({
                        showErrorTip: false
                    });
                }, 5000);
            });
        }
    }, {
        key: 'notActive',
        value: function notActive() {
            var message = _i18n2.default.NOT_ACTIVED;
            var activeLink = this.env.tbActiveUrl + this.activeToken;
            message = message.replace('{{activeLink}}', '<a target="_blank" href="' + activeLink + '">' + _i18n2.default.ACTIVE_PAGE + '</a>');
            this.setState({
                activeMessage: message,
                messageColorRed: true
            });
        }

        // 账号需要激活

    }, {
        key: 'showActiveBox',
        value: function showActiveBox() {
            var accout = this.cacheLoginId || '';
            var activeLink = this.env.tbActiveUrl + this.activeToken;
            var message = _i18n2.default.NEED_ACTIVE;
            message = message.replace('{{account}}', '<strong> ' + accout + ' </strong>');
            message = message.replace('{{activeLink}}', '<a target="_blank" href="' + activeLink + '">' + _i18n2.default.ACTIVE_PAGE + '</a>');
            this.setState({
                showActiveBox: true,
                activeMessage: message,
                showActiveBtn: true,
                showValidateBtn: false
            });
            document.getElementById('alibaba-login-box').style.display = 'none';
        }
    }, {
        key: 'smartLockSave',
        value: function smartLockSave(avatar_path) {
            var id = null;
            var pwd = null;
            this.setDocDomain();
            try {
                var newFrame = document.getElementById('alibaba-login-box');
                var frame = newFrame.contentDocument || newFrame.contentWindow.document;
                id = frame.getElementById('fm-login-id').value;
                pwd = frame.getElementById('fm-login-password').value;
            } catch (e) {
                _zoroArms2.default.error(e);
            }
            this.restoreDocDomain();
            if (id != null && id != '' && pwd != null && pwd != '') {
                var passwordCredential = new window.PasswordCredential({
                    id: id,
                    password: pwd,
                    iconURL: avatar_path
                });
                navigator.credentials.store(passwordCredential).then(function () {});
            }
        }
    }, {
        key: 'setDocDomain',
        value: function setDocDomain() {
            this.originalDomain = document.domain;
            document.domain = 'aliexpress.com';
        }
    }, {
        key: 'restoreDocDomain',
        value: function restoreDocDomain() {
            if (document.domain !== this.originalDomain) {
                document.domain = this.originalDomain;
            }
        }

        // 设置环境变量
        // setEnv(envMode) {
        //     // 用于调试：线下环境/线上环境
        //     if (envMode === 'test') {
        //         // passport.daily.alibaba.com
        //         Object.assign(this.env, DEVURL);
        //     } else if (envMode === 'run') {
        //         Object.assign(this.env, PROURL);
        //     }
        // }

    }, {
        key: 'setUrl',
        value: function setUrl(config) {
            this.env.recordProcessUrl = config.recordProcessUrl;
            this.env.validateStUrl = config.validateStUrl;
            this.env.havanaEmbedJsUrl = config.havanaEmbedJsUrl;
            this.env.havanaIframeUrl = config.havanaIframeUrl;
            this.env.smartlockLoginUrl = config.smartlockLoginUrl;
            this.env.tbSessionApplyStUrl = config.tbSessionApplyStUrl;
            this.env.tbSessionMiniApplyStUrl = config.tbSessionMiniApplyStUrl;
            this.env.tbActiveUrl = config.tbActiveUrl.replace(/amp;/g, '');
            this.env.emailVerificationUrl = config.emailVerificationUrl;
        }
    }, {
        key: 'setTbsessionWithoutResponse',
        value: function setTbsessionWithoutResponse(tbsessionToken) {
            if (typeof tbsessionToken === 'undefined' || tbsessionToken === null || tbsessionToken === '') {
                return;
            }
            var url = this.env.tbSessionApplyStUrl + '?site=13&token=' + tbsessionToken;
            new Image().src = url;
        }

        // 请求tvs接口，设置alibaba.com域cookie
        // 注：浏览器禁用第三方cookie的情况下，cookie设置不成功

    }, {
        key: 'setAlibabaCookie',
        value: function setAlibabaCookie(url) {
            var _this6 = this;

            this.props.toggleMask(true);
            var data = {
                moduleKey: 'common.xman.SetCookie',
                u_token: this.xmanConfig.u_token
            };
            var isTvsTimeout = false;
            var tvsTimeout = setTimeout(function () {
                // 5秒后触发afterLogin，tvs不能阻断登录
                _this6.props.toggleMask(false);
                isTvsTimeout = true;
                _this6.props.afterLogin(_this6.cacheLoginId);
            }, 5000);
            (0, _zoroRequest2.default)({
                url: url,
                data: data,
                type: 'script'
            }).then(function () {
                // 登录完成
                _this6.props.toggleMask(false);
                clearTimeout(tvsTimeout);
                if (!isTvsTimeout) {
                    _this6.props.afterLogin(_this6.cacheLoginId);
                }
            });
        }
    }, {
        key: 'setTbsession',
        value: function setTbsession(tbsessionToken) {
            var _this7 = this;

            if (typeof tbsessionToken === 'undefined' || tbsessionToken === null || tbsessionToken === '') {
                this.props.afterLogin(this.cacheLoginId);
                return;
            }
            this.props.toggleMask(true);
            var data = {
                site: 13,
                token: tbsessionToken
            };

            var isTbsessionTimeout = false;
            var tbsessionTimeout = setTimeout(function () {
                // 5秒后触发afterLogin，tvs不能阻断登录
                _this7.props.toggleMask(false);
                isTbsessionTimeout = true;
                _this7.props.afterLogin(_this7.cacheLoginId);
            }, 5000);

            (0, _zoroRequest2.default)({
                url: this.env.tbSessionMiniApplyStUrl,
                data: data,
                type: 'jsonp'
            }).then(function () {
                // 登录完成
                _this7.props.toggleMask(false);
                clearTimeout(tbsessionTimeout);
                if (!isTbsessionTimeout) {
                    _this7.props.afterLogin(_this7.cacheLoginId);
                }
            });
        }
    }]);
    return Login;
}(_react2.default.PureComponent), _class.defaultProps = {
    scene: 'AE_MAIN_LOGIN', // 标识登录场景AE_MAIN_LOGIN/AE_MSITE_LOGIN等
    appName: 'aebuyer', // 集团登录的appName，目前有aebuyer/aeseller两种，默认'aebuyer'
    isMobile: false, // 是否手机端
    notLoadSsoView: false,
    enableSmartLock: undefined, // 是否开启SmartLock功能，默认是undefined
    autoSmartLockLogin: false, // 是否开启SmartLock免打扰自动登录
    havanaQueryStr: null, // 初始化havana组件的参数

    toggleMask: _util2.noop, // 显示or隐藏遮罩
    afterHavanaInit: _util2.noop, // havana初始化事件
    afterSafetyCheck: _util2.noop, // havana初始化时 action == "ivinit" 事件
    afterLogin: _util2.noop, // login后事件
    afterLoginInit: _util2.noop
}, _initialiseProps = function _initialiseProps() {
    var _this8 = this;

    this.id = 'batman-login-wrap';
    this.originalDomain = document.domain;
    this.locale = '';
    this.fetchArgsCache = null;
    this.havanaInitTime = null;
    this.isUseNewSmartlockApi = (0, _util.isUseNewSmartlockApi)();
    this.enableSmartLock = this.props.enableSmartLock;
    this.xmanConfig = null;
    this.cacheSt = null;
    this.cacheLoginId = null;
    this.cacheAeLoginPattern = null;
    this.activeToken = null;
    this.env = {};
    this.recordTime = {};
    this.state = {
        showErrorTip: false,
        showActiveBox: false,
        activeMessage: '',
        showActiveBtn: false,
        showValidateBtn: false,
        messageColorRed: false,
        showForbidTip: false
    };

    this.onGotoActive = function () {
        window.open(_this8.env.tbActiveUrl + _this8.activeToken, '_blank');
        _this8.setState({
            showActiveBtn: false,
            showValidateBtn: true
        });
    };

    this.onCompleteActive = function () {
        _this8.validateST(_this8.cacheSt, _this8.cacheLoginId, true, _this8.cacheAeLoginPattern);
    };

    this.onUseOtherAccount = function () {
        _this8.hideActiveBox();
        _this8.initHavana({ notLoadSsoView: true });
    };

    this.initLoginFrame = function (opts) {
        var loginBox = document.getElementById('alibaba-login-box');
        loginBox.parentElement.removeChild(loginBox);
        _this8.initHavana(opts);
    };

    this.onLoginMessage = function (args) {
        if (!args.action) return;
        if (args.action === 'afterPageInit') {
            _this8.props.afterLoginInit((0, _extends3.default)({}, _this8.recordTime, {
                cfptPage: Date.now()
            }));
        }

        if (args.action === 'resizeIframe') return;

        if (args.action === 'afterInit' && _this8.isIniting) {
            //


            _this8.isIniting = false;
            _this8.fetchArgsCache = args;
            _this8.havanaInitTime = new Date();
            _this8.props.afterHavanaInit(args);
            if (_this8.enableSmartLock) {
                _this8.doSmartLockFetch(args, _this8.props.autoSmartLockLogin);
            }
        }

        if (args.action === 'ivinit') {
            // HavanaApp 的登录结果,Safety Check 消息在这里面暴露出来
            _this8.props.afterSafetyCheck(args);
        }

        if (args.action === 'loginResult' || args.action === 'hasLoginResult') {
            (0, _util.recordLoginStart)(args.aeLoginPattern, _this8.locale);
            if (args.resultCode == 100 && args.st) {
                // 验证st
                _this8.cacheSt = args.st;
                _this8.cacheLoginId = args.loginId;
                _this8.cacheAeLoginPattern = args.aeLoginPattern;
                _this8.validateST(args.st, args.loginId, false, args.aeLoginPattern);
            }
        }
    };
}, _temp2);
exports.default = Login;